/**
 * @file images.js
 * @description Centralized image URLs configuration
 */

export const IMAGES = {
  // Logo
  logo: '/logo/logo.png',
  
  // Homepage Service Highlights
  plumbingHome: '/images/plumbing-home.jpg',
  gasHome: '/images/gas-home.jpg',
  heatingHome: '/images/heating-home.jpg',
  emergencyHome: '/images/emergency-home.png',
  
  // About
  aboutMetro: '/images/about-metro.jpg',
  aboutPlaceholder: '/images/about-placeholder.jpg',
  metroBanner: '/images/banner.jpg',
  
  // Services Page
  plumbingServices: '/images/plumbing-services.png',
  gasServices: '/images/gas-services.png',
  heatingServices: '/images/heating-services.png',
  emergencyServices: '/images/emergency-services.png',
  servicePlaceholder: '/images/service-placeholder.jpg',
  
  // Projects
  projectBathroom: '/images/project-bathroom.jpg',
  projectBoiler: '/images/project-boiler.jpg',
  projectGasInspection: '/images/project-gas-inspection.jpg',
  projectEmergency: '/images/project-emergency.jpg',
  projectCentralHeating: '/images/project-central-heating.jpg',
  projectKitchen: '/images/project-kitchen.jpg',
  projectGasCooker: '/images/project-gas-cooker.jpg',
  projectRadiator: '/images/project-radiator.jpg',
  projectDrain: '/images/project-drain.jpg',
  projectPlaceholder: '/images/project-placeholder.jpg',
  
  // Google Reviews
  googleLogo: '/images/google-logo.png',
};

export default IMAGES;
